<template>
  <section>
    <h1
      class="primary--text headline pt-8"
    >
      {{ tituloPagina }}
    </h1>

    <v-img
      :alt="imgAlt"
      :src="require(`@/assets/img/${imgSrc}`)"
      :height="imgHeight"
      :width="imgWidth"
      class="mt-5"
    />

    <p
      class="primary--text mt-5 mb-8 mb-md-12"
    >
      {{ textoConteudo }}
    </p>

    <v-btn
      v-if="button"
      :href="linkBotao"
      outlined
      color="primary"
      class="botao-inicial"
      width="295"
      data-cy="button_ir_pagina_inicial"
    >
      {{ textoBotao }}
    </v-btn>
  </section>
</template>

<script>
export default {
  name: 'ErrorServidor',

  props: {
    button: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      tituloPagina: 'Esta página não está disponível no momento.',
      imgAlt: 'Imagem ilustrativa para erro de servidor.',
      imgSrc: 'erro-servidor.svg',
      imgHeight: '140',
      imgWidth: '260',
      textoConteudo: 'Infelizmente, não fomos capazes de acessar as informações no nosso servidor. Por favor, atualize a página ou tente acessar novamente mais tarde.',
      linkBotao: '/minhas-compras',
      textoBotao: 'Voltar à página inicial',
    };
  },
};
</script>
